import { FC } from 'react'
import { LoadingContainer } from './styles/NxCentralizedLoading.styles'
import { ClbLoading } from '@celebration/react'

type NxCentralizedLoadingProps = {
  ariaLabel?: string
}

const NxCentralizedLoading: FC<NxCentralizedLoadingProps> = ({ ariaLabel }): React.ReactElement => {
  return (
    <LoadingContainer>
      <ClbLoading size='lg' aria-label={ariaLabel} />
    </LoadingContainer>
  )
}

export default NxCentralizedLoading
